// @flow
import WebComponent from 'fg-frontend/src/webComponents/WebComponent';
import tippy        from 'tippy.js';

export default class Tooltip extends WebComponent {
  didMount() {
    tippy(this.element, {
      arrow: true,
      theme: 'esp',
    });
  }
}



// WEBPACK FOOTER //
// ./config/module-publish/resources-cvrez/js/components/Tooltip.js